<template>
  <LoadingScreen id="loading-screen-app" />
  <router-view />
  <Blobs />
  <Footer />
</template>

<script>
// import Swal from "sweetalert2";
import Blobs from "./components/stylistics/Blobs.vue";
import Footer from "./components/Footer.vue";
import LoadingScreen from "./components/LoadingScreen.vue";

export default {
  components: { Blobs, Footer, LoadingScreen },
  name: "App",
  mounted() {
    let loadingScreen = document.querySelector("#loading-screen-app");
    setTimeout(() => {
      // this.isLoading = false;
      loadingScreen.classList.add("fade-out");
    }, 1500);
  },
};
</script>

<style>
@import "styles/global-style.css";

#app {
  font-family: Comfortaa, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: #454545;
  /* margin-top: 60px; */
  width: 100%;
  min-height: 100vh;
  height: 100%;
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: center; */
  padding-block-end: 10em;
}

@media screen and (max-width: 30rem) {
  #app {
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    /* overflow: hidden; */
  }
}
</style>
